import { Divider } from '@/common/components/Divider/Divider';
import { Grid } from '@/common/components/Grid/Grid';
import { IconBadge } from '@/common/components/IconBadge/IconBadge';
import { Icon } from '@/common/components/Icons/Icon';
import { LogoAmericanExpress } from '@/common/components/Illustrations/CardBrands/LogoAmericanExpress';
import { LogoDinersClub } from '@/common/components/Illustrations/CardBrands/LogoDinersClub';
import { LogoDiscover } from '@/common/components/Illustrations/CardBrands/LogoDiscover';
import { LogoJCB } from '@/common/components/Illustrations/CardBrands/LogoJCB';
import { LogoMastercard } from '@/common/components/Illustrations/CardBrands/LogoMastercard';
import { LogoUnionPay } from '@/common/components/Illustrations/CardBrands/LogoUnionPay';
import { LogoVisa } from '@/common/components/Illustrations/CardBrands/LogoVisa';
import { Section } from '@/common/components/Section/Section';
import { Stack } from '@/common/components/Stack/Stack';

export const PlaygroundIcons = () => {
  return (
    <Stack gap="md">
      <Section title="IconBadge">
        <Stack horizontal gap="lg">
          <IconBadge ratio={32} icon={<Icon icon={'user'} />} />
          <IconBadge
            ratio={32}
            icon={<Icon icon={'credit-card'} />}
            backgroundColor={'accentSecondary30'}
          />
        </Stack>
      </Section>
      <Divider />
      <Section title="Icons">
        <Grid columnBasis="basis-[5rem]" gap="md">
          <Icon icon="user" />
          <Icon icon="id-card" />
          <Icon icon="family-pants" />
          <Icon icon="percent" />
          <Icon icon="language" />
          <Icon icon="question" />
          <Icon icon="file-lines" />
          <Icon icon="lock" />
          <Icon icon="chevron-right" />
          <Icon icon="arrow-up-right" />
          <Icon icon="check" />
          <Icon icon="eye-slash" />
          <Icon icon="eye" />
          <Icon icon="circle-exclamation" />
          <Icon icon="left-from-bracket" />
          <Icon icon="credit-card" />
          <Icon icon="minus" />
          <Icon icon="plus" />
          <Icon icon="arrow-left-long" />
          <Icon icon="pencil" />
          <Icon icon="home" />
          <Icon icon="utensils" />
          <Icon icon="seedling" />
          <Icon icon="coins" />
          <Icon icon="sparkles" />
          <Icon icon="tags" />
          <Icon icon="right-left" />
          <Icon icon="location-dot" />
          <Icon icon="shield-halved" />
          <Icon icon="chevron-down" />
          <Icon icon="chevron-up" />
          <Icon icon="baby" />
          <Icon icon="child" />
          <Icon icon="building" />
          <Icon icon="fingerprint" />
          <Icon icon="bell" />
          <Icon icon="download" />
          <Icon icon="upload" />
          <Icon icon="file-lock" />
          <Icon icon="file-pdf" />
          <Icon icon="piggy-bank" />
          <Icon icon="exclamation" />
          <Icon icon="info" />
          <Icon icon="circle-check" />
          <Icon icon="circle-exclamation" />
          <Icon icon="circle-info" />
          <Icon icon="money-bill-trend-up" />
          <Icon icon="shield-plus" />
          <Icon icon="star" />
        </Grid>
      </Section>
      <Divider />
      <Section title="CardBrands">
        <Stack horizontal gap="sm">
          <LogoAmericanExpress width={32} height={32} />
          <LogoDinersClub width={32} height={32} />
          <LogoDiscover width={32} height={32} />
          <LogoJCB width={32} height={32} />
          <LogoMastercard width={32} height={32} />
          <LogoUnionPay width={32} height={32} />
          <LogoVisa width={32} height={32} />
        </Stack>
      </Section>
      <Divider />
    </Stack>
  );
};
